import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import { ERROR_MESSAGES, GRL_URL } from '../../../../../../utils/pnd/PndConstants';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';
import renderSelectField from 'src/shared/components/form/Select';
import { isNumber, mobileNoFormat, mobileNoLength } from 'src/utils/validationUtils';
import { showNotification } from 'src/shared/components/Notification';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import Badge from "react-bootstrap/Badge";
const required = value => value ? undefined : 'Required'
const renderField = ({ input, label, placeholder, type, meta: { touched, error, warning }, disabled }) => (
    <div className="form__form-group">
        <div className="form__form-group">
            <input
                {...input}
                  className="custom-placeholder"
                placeholder={placeholder}
                type={type}
                disabled={disabled}  // Add the disabled prop here
            />
            {touched && ((error && <span className="form__form-group-error"> {label} {error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
)
const CustomerPrimaryAddressBookAddOrUpdate = ({ handleSubmit, setMapData, address, status, dispatch, setMapInfo, dataInfo }) => {
    useEffect(() => {
        getAllMerchantHubCustomerAddressBookDetails();

    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddress, setAddress] = useState(null);
    const [apaIframeUrl] = useState(GRL_URL);
    const apaFrameRef = useRef(null);
    const [isCustomersId, setCustomersId] = useState([]);
    // const [isNoRecordFound, setNoRecordFound] = useState(false);
    const [isAddressInfo, setAddressInfo] = useState([]);
    const [selectedPrimaryId, setSelectedPrimaryId] = useState(null); // Track the ID of the primary address
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const getHubCustomersAddressDetails = async (hubCustomerId) => {
        try {

            const response = await PndRestApi.GetHubCustomerAddressBook(hubCustomerId);
            if (response.status === 200 && response.data.status === 200) {
                setAddressInfo(response.data.data);
                // Initialize the selectedPrimaryId based on the fetched data
                const primaryAddress = response.data.data.find(row => row.addressType === 1);
                if (primaryAddress) {
                    setSelectedPrimaryId(primaryAddress.id);
                }
            } else if (response?.data?.status && response?.data?.status === 204) { // No Record Found
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                )
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                )
                return;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };
    const getAllMerchantHubCustomerAddressBookDetails = async () => {
        try {

            let customersId = [];
            const response = await PndRestApi.GetAllHubCustomers();
            if (response.status === 200 && response.data.status === 200) {
                const filteredData = response.data.data.filter(item => item.status === 1);
                filteredData.map(item => {
                    customersId.push({ "label": item.customerName, "value": item.hubCustomerId });
                })
                setCustomersId(customersId);
            } else if (response.status === 200 && response.data.status === 204) {

                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:Please create Hub Customer first`,
                );
                return;
            }
            else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data?.message}`,
                );
                return;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };
    const handleFindLocation = () => {
        toggleModal(); // Open the modal
        handleMessageToIframe(); // Send message to iframe
    };



    const handleMessageToIframe = () => {
        dispatch(change('CustomerAddressBookAddOrUpdateForm', 'buildingName', ""));
        const datajson = '{"RequestID": ' + Math.floor((Math.random() * 20) + 1) + ',"MessageType":1,"AddressElements": [{"AddressElementTypeCode": 1,"Value":""},{"AddressElementTypeCode":2,"Value": ""},{ "AddressElementTypeCode": 3,"Value": ""},{"AddressElementTypeCode":4,"Value": ""},{"AddressElementTypeCode": 5,"Value":"520950"},{"AddressElementTypeCode": 6,"Value":"" },{"AddressElementTypeCode": 7, "Value": "" },{"AddressElementTypeCode": 8,"Value":""}]}';
        if (apaFrameRef.current) {
            apaFrameRef.current.contentWindow.postMessage(datajson, '*');
            window.addEventListener('message', handleMessageFromIframe);
        } else {
            console.error('iframe element not found');
        }
    };

    let deliveryAddress = "";
    const handleMessageFromIframe = (event) => {
        if (event && event.data) {
            try {
                const jsonRegex = /^\s*(\{.*\}|\[.*\])\s*$/;
                if (jsonRegex.test(event?.data)) {
                    const data_from_apa = JSON.parse(event.data);
                    setMapInfo(data_from_apa);
                    const buildingName = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 6);
                    const landmark = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 4);
                    const street = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 3);
                    const area = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 2);
                    const zone = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 7);
                    const city = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 8);
                    const emirates = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 1);

                    if (buildingName) {
                        deliveryAddress = deliveryAddress + buildingName.Value + ",";
                        dispatch(change('CustomerPrimaryAddressBookAddOrUpdateForm', 'buildingName', buildingName.Value));
                    }
                    if (landmark && !buildingName === landmark) {
                        deliveryAddress = deliveryAddress + landmark.Value + ",";
                    }
                    if (street) {
                        deliveryAddress = deliveryAddress + street.Value + ",";
                    }
                    if (area) {
                        deliveryAddress = deliveryAddress + area.Value + ",";
                    }
                    if (zone) {
                        deliveryAddress = deliveryAddress + zone.Value + ",";
                    }
                    if (city) {
                        deliveryAddress = deliveryAddress + city.Value + ",";
                    }
                    if (emirates) {
                        deliveryAddress = deliveryAddress + emirates.Value;
                    }
                    if (deliveryAddress && deliveryAddress.includes(",,")) {
                        setAddress(deliveryAddress.replace(/,,/g, ','));
                        setMapData(deliveryAddress.replace(/,,/g, ','));
                    }
                    // Close the modal after getting the address
                    toggleModal();
                }
            } catch (error) {
                console.error('event.data is not a valid JSON string');
            }
        }
    };


    const getHubCustomersInfoById = async (hubCustomerId) => {
        try {

            const response = await PndRestApi.GetHubCustomerById(hubCustomerId);
            if (response.status === 200 && response.data.status === 200 && response.data.data.length > 0) {
                getHubCustomersAddressDetails(hubCustomerId);
                dispatch(change('CustomerAddressBookAddOrUpdateForm', 'customerCode', response.data?.data[0]?.customerCode));

            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
                return;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    }

    return (
        <form className="form-animated" onSubmit={handleSubmit}>
            <Col lg={12} md={12}>
                <Row style={{ marginBottom: '10px' }}>
                    {isAddressInfo && isAddressInfo.length > 0 ? (
                        <TableContainer component={Paper} style={{ width: '100%' }}>
                            <Table>
                                <TableHead>
                                    <TableRow style={{ background: "#21B368" }}>
                                        <TableCell>Address Type</TableCell>
                                        <TableCell>Customer Name</TableCell>
                                        <TableCell>Customer Code</TableCell>
                                        <TableCell>Address Title</TableCell>
                                        <TableCell>Address</TableCell>
                                        <TableCell>Mobile No.</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isAddressInfo.map(row => (
                                        <TableRow key={row.id}>
                                            <TableCell>
                                                <input
                                                    style={{ height: '20px' }}
                                                    type="radio"
                                                    name="primary-address"
                                                    value={row.id} // Use the address ID as the value
                                                    checked={selectedPrimaryId === row.id} // Compare IDs for checked status
                                                // onChange={(e) => handleChange(e, row.id)} // Use ID for setting the primary address
                                                />
                                                {row.addressType === 1
                                                    ? <Badge bg="success">Primary</Badge>
                                                    : <Badge bg="warning">Secondary</Badge>}
                                            </TableCell>
                                            <TableCell>{row.customerName}</TableCell>
                                            <TableCell>{row.customerCode}</TableCell>
                                            <TableCell>{row.addressBookName}</TableCell>
                                            <TableCell>{row.address}</TableCell>
                                            <TableCell>{row.mobileNo}</TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <div>No address information available.</div>
                    )}
                </Row>
                <Row>
                    {!dataInfo ?
                        <Col lg={6} md={6}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Customer Name</span>
                                <div className="form__form-group-field">
                                    <Field
                                        validate={[required]}
                                        name="customerName"
                                        component={renderSelectField}
                                        type="text"
                                        options={isCustomersId}
                                        label="Customer"
                                        placeholder="Select Customer" onChange={(events) => getHubCustomersInfoById(events?.value)}
                                    />
                                </div>
                            </div>
                        </Col> :
                        <Col lg={6} md={6}>
                            <div className="form__form-animated-group">
                                <span className='required_field'>* </span><span className="form__form-animated-group-label">Customer Name</span>
                                <div className="form__form-group-field">
                                    <Field name="customerName" component={renderField} type="text" placeholder="Customer Code" validate={[required]} disabled={true} />
                                </div>
                            </div>
                        </Col>
                    }
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Customer Code</span>
                            <div className="form__form-group-field">
                                <Field name="customerCode" component={renderField} type="text" placeholder="Customer Code" validate={[required]} disabled={true} />
                            </div>
                        </div>
                    </Col>

                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Mobile Number</span>
                            <div className="form__form-group-field">
                                <Field name="mobileNo" component={renderField} type="text" placeholder="Mobile No." validate={[required, mobileNoFormat, mobileNoLength]} />
                            </div>
                        </div>
                    </Col>


                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">Telephone No.</span>
                            <div className="form__form-group-field">
                                <Field name="telephoneNo" component={renderField} type="text" placeholder="Telephone No." validate={isNumber} />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">Contact Name</span>
                            <div className="form__form-group-field">
                                <Field name="contactName" component={renderField} type="text" placeholder="Contact Name" />
                            </div>
                        </div>
                    </Col>



                </Row>
                <Row>
                    <Col md={3} lg={3}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Address Label
                            </span>
                            <div className="form__form-animated-group-field">

                                <Field
                                    validate={[required]}
                                    name="addressBookName"
                                    component={renderSelectField}
                                    type="text"
                                    options={[
                                        { value: 1, label: "Home" },
                                        { value: 2, label: "Work" },
                                        { value: 3, label: "Other" },
                                    ]}
                                    label="Address Label"
                                    placeholder="Label"

                                />

                            </div>
                        </div>
                    </Col>

                    <Col md={9} lg={9}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Address
                            </span>
                            <div className="form__form-animated-group-field">

                                <input
                                    validate={required}
                                    component="textarea"
                                    name="address"
                                    type="text"
                                    value={isAddress || address}
                                    label="Customer Address"
                                    placeholder="Customer Address"
                                />
                                <AddLocationAltIcon color="success" fontSize="large" style={{ cursor: 'pointer' }} onClick={handleFindLocation} />
                            </div>
                        </div>
                    </Col>
                    {/* <Col md={4} lg={4}>
                        <div className="form__form-animated-group">
                            <span className="required_field">* </span>{" "}
                            <span className="form__form-animated-group-label">
                                Pick Up Point GRC
                            </span>
                            <div className="form__form-animated-group-field">
                                <Field
                                    component={renderField}
                                    name="address"
                                    type="text"
                                    disabled={true}

                                />

                            </div>
                        </div>
                    </Col> */}
                    {/* GRC - 17 digit number */}
                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Building Name</span>
                            <div className="form__form-group-field">
                                <Field name="buildingName" component={renderField} type="text" placeholder="Building Name" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">PO Box No.</span>
                            <div className="form__form-group-field">
                                <Field name="poBoxNo" component={renderField} type="text" placeholder="PO Box No." validate={[required, isNumber]} />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Floor Number</span>
                            <div className="form__form-group-field">
                                <Field name="floorNo" component={renderField} type="text" placeholder="Floor Number" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className='required_field'>* </span>  <span className="form__form-animated-group-label">Door Number</span>
                            <div className="form__form-group-field">
                                <Field name="doorNo" component={renderField} type="text" placeholder="Door Number" validate={[required]} />
                            </div>
                        </div>
                    </Col>
                </Row><Row>
                    <Col lg={6} md={6}>
                        <div className="form__form-animated-group">
                            <span className="form__form-animated-group-label">Remarks</span>
                            <div className="form__form-group-field">
                                <Field name="faxNo" component="textarea" type="text" placeholder="Remarks" />
                            </div>
                        </div>
                    </Col>


                    <Col lg={3} md={3}>
                        <div className="form__form-animated-group">
                            <div className="form__form-group">
                                <span className="required_field">* </span>{" "}
                                <span className="form__form-animated-group-label">Primary Address?</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="status"
                                        component={renderToggleButtonField}
                                        defaultChecked={status ? status : false}
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>

                </Row>
            </Col>

            <div className="form__OnboardingButton">
                <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                    <Button color="primary" type="submit" className="next" onClick={handleSubmit}>Submit</Button>
                </ButtonToolbar>
            </div>
            <Modal isOpen={isModalOpen} toggle={toggleModal} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggleModal}><b>Find Location</b></ModalHeader>
                <ModalBody>
                    <iframe ref={apaFrameRef} src={apaIframeUrl} width="100%" height="400px" title="Get Address" onLoad={handleMessageToIframe} style={{ width: '100%', height: '650px' }}></iframe>
                </ModalBody>
            </Modal>
        </form>

    );
};


CustomerPrimaryAddressBookAddOrUpdate.propTypes = {
    CustomerPrimaryAddressBookAddOrUpdate: PropTypes.func.isRequired,
};

const getAddressBookNameInitialValue = (dataInfo) => {
    if (dataInfo) {
        switch (dataInfo) {
            case "Home":
                return { value: 1, label: "Home" };
            case "Work":
                return { value: 2, label: "Work" };
            case "Other":
                return { value: 3, label: "Other" };
            default:
                return null;
        }
    }
    return null;
};
const mapStateToProps = (state, data) => {
    if (data && data?.dataInfo) {
        return {
            initialValues: {
                hubCustomerId: data?.dataInfo.hubCustomerId,
                customerName: data?.dataInfo.customerName,
                customerCode: data?.dataInfo.customerCode,
                buildingName: data?.dataInfo.buildingName,
                telephoneNo: data?.dataInfo.telephoneNo,
                customerContactName: data?.dataInfo.customerContactName,
                mobileNo: data?.dataInfo.mobileNo,
                latitude: data.dataInfo.latitude,
                poBoxNo: data.dataInfo.poBoxNo,
                contactName: data.dataInfo.contactName,
                doorNo: data.dataInfo.doorNo,
                floorNo: data.dataInfo.floorNo,
                hubCustomerAddBookId: data?.dataInfo?.hubCustomerAddBookId,
                addressBookName: getAddressBookNameInitialValue(data.dataInfo.addressBookName),
                faxNo: data?.dataInfo.faxNo,


            }
        }

    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'CustomerAddressBookAddOrUpdateForm', enableReinitialize: true })(CustomerPrimaryAddressBookAddOrUpdate))